<template>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialogConfirm')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialogConfirm"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogConfirm()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap justify-space-between>
            <v-flex xs12>
			  <div v-if="!loadingRes && !contentDialogRes.length" v-html="contentDialogConfirm"></div>
			  <div v-else class="tf_loading_url">
			  	<div class="tf_contentLoading">
			  		<div v-if="loadingRes" class="text-xs-center">
			  			<v-progress-circular
			  				:rotate="-90"
			  				:size="120"
			  				:width="8"
			  				:value="loadingValue"
			  				color="primary"
			  			>
			  				{{ loadingValue }} %
			  			</v-progress-circular>
			  		</div>
			  		<div v-if="contentDialogRes.length" class="tf_contentLoadingTxt">
			  			<div class="contentLoading" v-html="contentDialogRes"></div>
			  		</div>
			  	</div>
			  </div>
            </v-flex>
            <v-flex xs12 v-if="!contentDialogRes.length">
              <p><v-spacer></v-spacer></p>
              <v-divider ></v-divider>
              <p><v-spacer></v-spacer></p>
            </v-flex>
            <!-- Actions pour la selection -->
            <v-flex xs12 v-if="!contentDialogRes.length">
              Choissez le prompt :<br>
               <v-select
               	v-model="selectActionPrompt"
               	:items="computedActionUrl"
               	item-text="text"
               	item-value="id"
               	@change="actionsPrompt()"
               >
               </v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
		

            <v-card-text>
              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <div class="table-scroll-area">
                    <v-data-table
                      :headers="headersFAQ"
                      :items="prompts"
                      item-key="index"
                      :loading="loadingData"
                      class="elevation-1"
                      :rows-per-page-items="[10, 25, 50]"
                    >
                      <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-xs-left" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.date }}</td>
                          <td class="text-xs-left" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.name }}</td>
                          <td class="text-xs-left" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.llm }}</td>
                          <td class="text-xs-left" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.temperature }}</td>
                          <td class="text-xs-left truncate-text" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.preview }}</td>
                          <td class="text-xs-right">
                            <!-- Editer -->
                            <v-tooltip left >
                              <template slot="activator">
                                <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateFAQ(props.item)" >edit</v-icon>
                              </template>
                              <span>Voir</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>


        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && !modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn v-if="!loadingModifFAQ" flat @click="closeDialogConfirm()">{{ $t('no') }}</v-btn>
          <v-btn 
            :loading="loadingModifFAQ"
            :disabled="!selectActionPrompt.length"
            color="primary"
            @click="submitDialogConfirm()"
          >{{ $t('search') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialogConfirm')">{{ $t('close') }}</v-btn>
          <v-btn color="primary" @click="$emit('closeDialogConfirm')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialogConfirm()">{{ $t('close') }}</v-btn>
        </v-card-actions>
		
      <!-- dialog comparaison prompt actuel vs historique -->
      <v-dialog
        v-model="showDialogComparePrompt"
        persistent
        scrollable
        max-width="90%"
      >
        <v-card>
          <v-card-title class="primary white--text compare-title">
            <v-btn icon dark @click="closeCompareDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span class="title compare-title-text">Comparaison des prompts</span>
          </v-card-title>
          <v-card-text class="compare-body">
            <div class="mb-3">
              <strong>Section:</strong> {{ selectedPromptField() }}
            </div>
            <v-layout row wrap>
              <v-flex xs12 md6 class="pr-3 compare-col">
                <h3 class="mb-2 compare-label">Prompt actuel</h3>
                <v-textarea
                  :value="getCurrentPromptValue()"
                  readonly
                  auto-grow
                  rows="12"
                  outline
                ></v-textarea>
              </v-flex>
              <v-flex xs12 md6 class="pl-3 compare-col">
                <h3 class="mb-2 compare-label">Version historisée</h3>
                <v-textarea
                  :value="getHistoricPromptValue()"
                  readonly
                  auto-grow
                  rows="12"
                  outline
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn flat @click="closeCompareDialog">{{ $t('close') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              :disabled="!canDeleteSelectedVersion()"
              @click="openConfirmDeleteDialog"
            >
              Supprimer cette version
            </v-btn>
            <v-btn
              color="warning"
              :disabled="selectedPromptField() === 'preview' || !selectedPromptVersion"
              @click="openConfirmRestoreDialog"
            >
              Restaurer cette version
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showDialogConfirmRestore"
        persistent
        max-width="560"
      >
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>
          <v-card-text>
            Le prompt actuel de la section <strong>{{ selectedPromptField() }}</strong> sera ecrase par la version historisee.
            <br>
            Voulez-vous continuer ?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogConfirmRestore = false">Annuler</v-btn>
            <v-btn color="warning" @click="confirmRestorePromptSection">Confirmer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showDialogConfirmDelete"
        persistent
        max-width="560"
      >
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>
          <v-card-text>
            Cette action va supprimer definitivement la version historisee selectionnee.
            <br>
            Voulez-vous continuer ?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogConfirmDelete = false">Annuler</v-btn>
            <v-btn color="error" :loading="loadingDeleteVersion" @click="confirmDeleteVersion">Supprimer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
</template>

<script>
export default {
  props: {
    showDialogConfirmation: {
      type: Boolean,
      default: false
    },
    loadingModifFAQ: {
      type: Boolean,
      default: false
    },
    loadingRes: {
      type: Boolean,
      default: false
    },
    contentDialogConfirm: {
      type: String,
      default: ''
    },
    contentDialogRes: {
      type: String,
      default: ''
    },
    titleDialogConfirm: {
      type: String,
      default: 'Confirmation'
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    modifBaseCo: {
      type: Boolean,
      default: false
    },
    startLoading: {
      type: Number,
      default: 0
    },
    endLoading: {
      type: Number,
      default: 0
    },
    currentPromptData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectActionPrompt: [],
      checkboxMAJ: false,
      page: '',
      showDialogComparePrompt: false,
      showDialogConfirmRestore: false,
      showDialogConfirmDelete: false,
      loadingDeleteVersion: false,
      selectedPromptVersion: null,
      prompts: [],
      promptsOriginal: [],
      headersFAQ: [
        { text: 'date', align: 'left', value: 'date', sortable: false },
        { text: 'nom / commentaire', align: 'left', value: 'name', sortable: false },
        { text: 'llm', align: 'left', value: 'llm', sortable: false },
        { text: 'temperature', align: 'left', value: 'temperature', sortable: false },
        { text: 'apercu', align: 'left', value: 'preview', sortable: false },
        { text: 'Voir', align: 'right', value: 'update', sortable: false }
      ],
      loadingData: true
    }
  },
  computed: {
    computedActionUrl () {
      let actions = [
        {text: this.$t('personality'), id: 'personality'},
        {text: this.$t('environment'), id: 'environment'},
        {text: this.$t('objectif'), id: 'objectif'},
        {text: this.$t('communication'), id: 'communication'},
        {text: this.$t('questions'), id: 'questions'},
        {text: this.$t('rules'), id: 'rules'},
        {text: this.$t('tools'), id: 'tools'},
        {text: this.$t('custom'), id: 'custom'}
      ]
      return actions
    },
    loadingValue () {
      return Math.round((this.startLoading * 100) / this.endLoading)
    }
  },
  mounted () {
  },
  updated () {
  },
  created () {
    // recupère les données
    this.axios.get('get/prompt_version.php?sitekey=' + this.$store.state._Sites.siteSelected.LIC_KEY)
    .then(response => {
      const resAjx = response.data
      this.prompts = resAjx
      this.promptsOriginal = resAjx
      this.loadingData = false
    })
    .catch()
    .then(_ => {
      // this.loading = false
    })
  },
  methods: {
    closeDialogConfirm () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialogConfirm')
      } else {
        this.$emit('justCloseDialogConfirm')
      }
    },
    submitDialogConfirm () {
      this.$emit('submitDialogConfirm', this.selectActionPrompt, this.checkboxMAJ, this.page)
    },

    actionsPrompt () {
      if (!this.selectActionPrompt) return

      const field = this.selectActionPrompt // id choisi dans le v-select

      this.prompts = this.promptsOriginal.map(p => {
        return {
          ...p,
          preview: p[field] || '' // remplace "preview" par la valeur choisie
        }
      })
    },

    openDialogUpdateFAQ (data) {
      this.selectedPromptVersion = data
      this.showDialogComparePrompt = true
    },
    closeCompareDialog () {
      this.showDialogComparePrompt = false
      this.selectedPromptVersion = null
      this.showDialogConfirmRestore = false
      this.showDialogConfirmDelete = false
    },
    openConfirmRestoreDialog () {
      if (!this.selectedPromptVersion) return
      if (this.selectedPromptField() === 'preview') return
      this.showDialogConfirmRestore = true
    },
    confirmRestorePromptSection () {
      const field = this.selectedPromptField()
      const value = this.getHistoricPromptValue()
      this.$emit('restorePromptSection', field, value)
      this.showDialogConfirmRestore = false
      this.closeCompareDialog()
    },
    canDeleteSelectedVersion () {
      if (!this.selectedPromptVersion) return false
      return String(this.selectedPromptVersion.is_backup) === '1'
    },
    openConfirmDeleteDialog () {
      if (!this.canDeleteSelectedVersion()) return
      this.showDialogConfirmDelete = true
    },
    confirmDeleteVersion () {
      if (!this.selectedPromptVersion) return

      const dataToPost = new window.FormData()
      dataToPost.append('sitekey', this.$store.state._Sites.siteSelected.LIC_KEY)
      dataToPost.append('prompt_date_raw', this.selectedPromptVersion.date_raw || '')
      dataToPost.append('prompt_user_id', this.selectedPromptVersion.user || '')
      dataToPost.append('prompt_isbackup', this.selectedPromptVersion.is_backup)

      this.loadingDeleteVersion = true
      this.axios.post('post/delete_prompt_version.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(() => {
        this.showDialogConfirmDelete = false
        this.closeCompareDialog()
        return this.axios.get('get/prompt_version.php?sitekey=' + this.$store.state._Sites.siteSelected.LIC_KEY)
      })
      .then(response => {
        if (!response) return
        const resAjx = response.data
        this.prompts = resAjx
        this.promptsOriginal = resAjx
      })
      .catch(() => {})
      .then(() => {
        this.loadingDeleteVersion = false
      })
    },
    selectedPromptField () {
      if (typeof this.selectActionPrompt === 'string' && this.selectActionPrompt.length) {
        return this.selectActionPrompt
      }
      return 'preview'
    },
    getCurrentPromptValue () {
      const field = this.selectedPromptField()
      if (!this.currentPromptData) return ''
      return this.currentPromptData[field] || ''
    },
    getHistoricPromptValue () {
      const field = this.selectedPromptField()
      if (!this.selectedPromptVersion) return ''
      return this.selectedPromptVersion[field] || this.selectedPromptVersion.preview || ''
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .tf_loading_url {
    height: 400px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .tf_text_url {
    height: 400px;
    display: flex;
    flex-direction: column;
  }
  .contentLoading {
    padding-top: 20px;
  }
  .v-progress-circular {
    margin: 1rem;
  }
  .v-progress-circular__overlay {
    stroke: currentColor;
    z-index: 2;
    transition: all 0.6s ease-in-out;
  }
  .tf_contentLoading{
    height: 100%;
    width: 100%;
  }

  .contentLoading {
    height: 100%;
    padding-bottom: 20px;
  }
  .tf_contentLoading h3 {
    text-align: left;
  }
  .loadingNum {
    text-align: center;
  }
  .tf_contentLoading .listeUrlsError {
    text-align: left;
  }
  .tf_contentLoading .listeUrlsError li {
    font-weight: 500;
  }
  .truncate-text {
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .compare-col {
    margin-bottom: 12px;
  }
  .compare-body {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .compare-body .layout {
    margin-left: 0;
    margin-right: 0;
  }
  .compare-body .flex {
    padding-left: 0;
    padding-right: 0;
  }
  .compare-label {
    margin-left: 0;
  }
  .compare-title {
    align-items: center;
  }
  .compare-title-text {
    line-height: 1.2;
  }
  .table-scroll-area {
    max-height: 55vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogVersionPrompt.vue